import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getOverlays = (state: RootState) => state.pages.editor.overlays;

const getAllOverlays = createSelector([getOverlays], (overlays) => overlays);

export default getAllOverlays;
